/**
 * Utility functions for handling HTML content
 */

/**
 * Decodes HTML entities in a string
 * @param html - The HTML string that may contain encoded entities
 * @returns Decoded HTML string
 */
export const decodeHTMLEntities = (html: string): string => {
  if (!html || typeof html !== 'string') {
    return html;
  }

  // Check if the content contains HTML entities
  if (html.includes('&lt;') || html.includes('&gt;') || html.includes('&amp;') || html.includes('&quot;')) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
  }

  return html;
};

/**
 * Ensures HTML content is properly formatted for dangerouslySetInnerHTML
 * @param content - The content to process (could be plain text or HTML)
 * @returns Properly formatted HTML string
 */
export const prepareHTMLContent = (content: string): string => {
  if (!content || typeof content !== 'string') {
    return '';
  }

  console.log('prepareHTMLContent input:', content);
  console.log('prepareHTMLContent input type:', typeof content);

  // First decode any HTML entities
  let processedContent = decodeHTMLEntities(content);
  console.log('After decoding:', processedContent);

  // If the content doesn't contain HTML tags, wrap it in a paragraph
  if (!processedContent.includes('<') && !processedContent.includes('>')) {
    processedContent = `<p>${processedContent}</p>`;
    console.log('Wrapped in paragraph:', processedContent);
  }

  console.log('Final processed content:', processedContent);
  return processedContent;
};

/**
 * Checks if a string contains HTML content
 * @param content - The content to check
 * @returns True if content appears to be HTML
 */
export const isHTMLContent = (content: string): boolean => {
  if (!content || typeof content !== 'string') {
    return false;
  }

  // Look for HTML tags or encoded HTML
  return content.includes('<') || content.includes('&lt;');
};
